import React from 'react';
import Link from 'gatsby-link';

import { 
  PostPreviewWrapper,
  PostPreviewTitle,
  PostPreviewTeaser,
  PostPreviewMetaWrapper,
} from './styled';

import { Lozenge } from '../Lozenge';
import { Meta } from '../Meta';
import { getExcerpt } from '../../utils';

export const Preview = (props) => {
  return (
    <PostPreviewWrapper>
      <div>
        <Lozenge 
          type={props.category}
        />
      </div>
      <PostPreviewTitle>
        <Link to={props.slug}>
          {props.title}
        </Link>
      </PostPreviewTitle>
      <PostPreviewTeaser dangerouslySetInnerHTML={{ __html: getExcerpt(props.excerpt) }} />
      <PostPreviewMetaWrapper> 
        <Meta 
          avatar={props.avatar}
          name={props.name}
          date={props.createdAt}
          size='normal'
        />
      </PostPreviewMetaWrapper>
    </PostPreviewWrapper>
  );
}


// WEBPACK FOOTER //
// ./src/components/Preview/index.js